import { NgxExtendedPdfViewerService } from 'ngx-extended-pdf-viewer';
import { GlobalWorkerOptions } from 'pdfjs-dist';

export function configurePdfViewer(pdfViewerService: NgxExtendedPdfViewerService) {
  // Set the worker path to use the local worker file
  GlobalWorkerOptions.workerSrc = '/assets/pdf-2.14.311-es5.min.js';
} 
